import { Component, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TextUtils } from "../../../../util/TextUtils";
import { CookieService } from "ngx-cookie-service";
import { StorageService } from "app/main/module/common/service/storage.service";
import * as moment from "moment";
import {
    APP_DATE_FORMATS,
    AppDateAdapter,
} from "../../report/format-datepicker";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Globals } from "../../../common/global";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Case } from "../case";
import { CasesService } from "../cases.service";
import { Subscription } from "rxjs";
import { AssignService } from "../../cassette/assign/assign.service";
import { TimestampService } from "app/main/module/common/timeConstant.service";
import { ReminderRefreshService } from "../reminderRefresh.service";

const timeZone = require("moment-timezone");
@Component({
    selector: "edit-case-dialog",
    templateUrl: "edit-case-dialog.component.html",
    styleUrls: ["edit-case-dialog.component.scss"],
    providers: [
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    ],
})
export class EditCaseDialogComponent implements OnInit {
    [x: string]: any;
    patientForm: FormGroup;
    platform = "web";
    @Input()
    min: "D" | null;
    today = new Date();
    isEnterPressed = false;
    hasFirstDataShown: Boolean;
    dobStamp = 0;
    dobString = "";
    deleted: boolean;
    rowId: any;
    memberInfo: any;
    errorMessage: any;
    @ViewChild("input", { static: true }) input: any;
    @ViewChild("filter", { static: true }) filter: any;
    searchInputSubscription: Subscription;
    message: any;
    inputValue: string;
    filteredPatients: Array<any> = [];
    HASH = "#";
    showNoResultsMessage = false;
    isLoading = false;
    patientlist: Array<any> = [];
    receivedOn: Date | string = "";
    patientBookedOn: Date | string = "";
    status: string = "";
    defaultTz: string = "";
    name: string;
    selectLab: string;
    labName: string;
    labs = [
        { id: "demolab", name: "Sterilwize Demo Lab" },
        { id: "awdheshdental", name: "AwadheshDental" },
        { id: "electriccitydental", name: "Electric City Dental" },
        { id: "richlab", name: "rich dental Lab" },
        { id: "anulab", name: "Anu Lab" },
        { id: "lasicdental", name: "Lasic Dental" },
        { id: "davedental", name: "DAVE Dental" },
        { id: "templatelab", name: "Template Lab" },
        { id: "frenchdemolab", name: "Sterilwize French Demo Lab" },
        { id: "piyushdental", name: "Piyush Dental" },
    ];
    labTimeZone: string;
    uniqueTimestamp: any;
    currentDate: Date;
    startAt: any;
    requestedOnDate: any;
    recivedOnDate: any;

    constructor(
        public dialogRef: MatDialogRef<EditCaseDialogComponent>,
        private _formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
        private userService: StorageService,
        private cookieService: CookieService,
        private global: Globals,
        private router: Router,
        private httpClient: HttpClient,
        @Inject(MAT_DIALOG_DATA) public data: Case,
        public translate: TranslateService,
        public caseService: CasesService,
        public paginationService: AssignService,
        public timeStampService: TimestampService,
        public reminderRefreshService: ReminderRefreshService
    ) {
        this.currentDate = new Date();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    /**
     * On init
     */
    ngOnInit(): void {
        // Validators.pattern(/^\S*$/)
        this.getSingleCase();
        this.patientForm = this._formBuilder.group({
            // Validators.pattern(/^\S+/)
            patientId: [
                { value: "", disabled: true },
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            title: [
                { value: "", disabled: true },
                [Validators.required, Validators.pattern(/^[^\s].*$/)],
            ],
            selectLab: [
                { value: "", disabled: true },
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            patientName: [
                { value: "", disabled: true },
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            description: ["", [this.wordCountValidator(50)]],
            requestedOn: [{ value: "", disabled: true }, ""],
            probableReceiveDate: [{ value: "", disabled: true }, ""],
            receivedOn: [{ value: "", disabled: false }, ""],
            paitentBookedOn: [{ value: "", disabled: true }, ""],
        });
        this.defaultTz = this.userService.getCookie("defaultTz") || "UTC";
        // this.setFocus();
        this.name = this.userService.getCookie("name");
        this.labTimeZone = localStorage.getItem("defaultTz");

        this.timeStampService.timestamp$.subscribe((ts) => {
            this.uniqueTimestamp = ts;
        });
    }

    toUpperCaseString(str) {
        return str.trim().toUpperCase();
    }

    openSnackBar(message: string, action: string): void {
        this.hasFirstDataShown = true;
        this.snackBar.open(message, action, {
            duration: 10000,
        });
    }

    private handleError(error: Error): void {
        this.openSnackBar(error.message, "OK");
        // this.notify.update(error.message, 'error');
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    toLabMidnightTimestamp(date: Date | string, labTimezone: string): number {
        const dateString = moment(date).format("YYYY-MM-DD");
        return moment.tz(dateString, "YYYY-MM-DD", labTimezone).valueOf();
    }

    getSingleCase(): void {
        this.id = this.dialogRef.componentInstance.data.id;
        this.status = this.dialogRef.componentInstance.data.status;
        this.hasFirstDataShown = true;

        this.caseService.getSingleCase(this.id).subscribe(
            (response: any) => {
                if (response && response.data) {
                    const caseData = response.data;
                    this.hasFirstDataShown = false;
                    this.requestedOnDate = caseData[0].requested_on
                        ? moment(Number(caseData[0].requested_on))
                              .tz(this.defaultTz)
                              .toDate()
                        : "";
                    this.receivedOnDate = caseData[0].received_on
                        ? moment(Number(caseData[0].received_on))
                              .tz(this.defaultTz)
                              .toDate()
                        : "";

                    this.patientForm.patchValue({
                        patientId: caseData[0].patient_id,
                        title: caseData[0].title,
                        patientName: caseData[0].patient_name,
                        selectLab: caseData[0].lab_id,
                        description: caseData[0].description,
                        requestedOn: moment(Number(caseData[0].requested_on))
                            .tz(this.defaultTz)
                            .toDate(),
                        probableReceiveDate: moment(
                            Number(caseData[0].probable_received_date)
                        )
                            .tz(this.defaultTz)
                            .toDate(),
                        receivedOn: caseData[0].received_on
                            ? moment(Number(caseData[0].received_on))
                                  .tz(this.defaultTz)
                                  .toDate()
                            : "",
                        paitentBookedOn: caseData[0].patient_booked_on
                            ? moment(Number(caseData[0].patient_booked_on))
                                  .tz(this.defaultTz)
                                  .toDate()
                            : "",
                    });

                    this.receivedOn = caseData[0].received_on
                        ? new Date(caseData[0].received_on)
                        : "";
                    this.patientBookedOn = caseData[0].patient_booked_on
                        ? new Date(caseData[0].patient_booked_on)
                        : "";

                    if (this.status === "received") {
                        this.patientForm.get("paitentBookedOn")?.enable();
                        this.patientForm
                            .get("paitentBookedOn")
                            ?.setValidators(Validators.required);
                    } else {
                        this.patientForm.get("paitentBookedOn")?.disable();
                        this.patientForm
                            .get("paitentBookedOn")
                            ?.clearValidators();
                    }

                    this.patientForm
                        .get("paitentBookedOn")
                        ?.updateValueAndValidity();
                } else {
                    this.hasFirstDataShown = false;
                    this.openSnackBar(
                        this.translateSentence("Common.noDataFound"),
                        this.translateSentence("Common.ok")
                    );
                }
            },
            (error) => {
                this.hasFirstDataShown = false;
                this.handleError(error);
            }
        );
    }

    updateCase(): void {
        let caseStatus = this.status;
        this.hasFirstDataShown = true;
        // console.log(this.patientForm.value);

        if (this.status === "assigned" && this.patientForm.value.receivedOn) {
            caseStatus = "received";
        }

        if (
            caseStatus === "received" &&
            this.patientForm.value.receivedOn &&
            this.patientForm.value.paitentBookedOn
        ) {
            caseStatus = "completed";
        }

        const caseData: Case = {
            description: this.patientForm.value.description,

            received_on: this.patientForm.value.receivedOn
                ? this.toLabMidnightTimestamp(
                      this.patientForm.value.receivedOn,
                      this.labTimeZone
                  ).toString()
                : "",

            patient_booked_on: this.patientForm.value.paitentBookedOn
                ? this.toLabMidnightTimestamp(
                      this.patientForm.value.paitentBookedOn,
                      this.labTimeZone
                  ).toString()
                : "",

            ...(caseStatus !== this.status && { status: caseStatus }),

            updated: this.uniqueTimestamp
                ? moment(this.uniqueTimestamp).utc().valueOf().toString()
                : moment.utc().valueOf().toString(),

            updated_by: this.name,

            updated_timestamp: this.uniqueTimestamp
                ? moment(this.uniqueTimestamp).utc().valueOf().toString()
                : moment.utc().valueOf().toString(),
        };

        this.caseService.updateCase(caseData, this.id).subscribe(
            (response) => {
                if (response && response.status === "success") {
                    this.openSnackBar(
                        this.translateSentence(
                            "LabCases.caseUpdatedSuccessfully"
                        ),
                        this.translateSentence("Common.ok")
                    );
                    this.hasFirstDataShown = false;
                    this.dialogRef.close();
                    this.reminderRefreshService.triggerRefresh();
                } else {
                    this.openSnackBar(
                        this.translateSentence("LabCases.caseUpdateFailed"),
                        this.translateSentence("Common.ok")
                    );
                }
            },
            (error) => {
                this.handleError(error);
            }
        );
    }

    wordCountValidator(maxWords: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) return null;
            const trimmed = control.value.trim();

            if (trimmed.length === 0) {
                return { whitespaceOnly: true };
            }

            const wordCount = trimmed.trim().split(/\s+/).length;
            return wordCount > maxWords
                ? { wordLimit: { maxWords, actual: wordCount } }
                : null;
        };
    }

    fromDateValueChange(event: any) {
        this.startAt = event;
    }
}
